export const SNACKBAR_DURATION = 5_000;
